import { render, staticRenderFns } from "./sch_add.vue?vue&type=template&id=5d64d2b9&scoped=true"
import script from "./sch_add.vue?vue&type=script&lang=js"
export * from "./sch_add.vue?vue&type=script&lang=js"
import style0 from "./sch_add.vue?vue&type=style&index=0&id=5d64d2b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d64d2b9",
  null
  
)

export default component.exports